export const cardName = (fullName: string) => {
  const names = fullName.split(' ');

  const firstName = names[0];

  const lastName = names[names.length - 1];

  const middleNames = names.filter((item) => item !== firstName && item !== lastName);

  const maxLength = 19;

  if (middleNames.length) {
    let middleName: string;

    if (middleNames.length > 1) {
      middleName = middleNames.reduce((a, b) => (a.length > b.length ? a : b));
    } else {
      middleName = middleNames[0];
    }

    const middleNameFirstLetter = middleName.charAt(0);

    const middleNameOption = `${firstName} ${middleNameFirstLetter} ${lastName}`;

    if (middleNameOption.length <= maxLength) {
      return middleNameOption;
    }
  }

  const firstAndLastNameOption = `${firstName} ${lastName}`;

  if (firstAndLastNameOption.length <= maxLength) {
    return firstAndLastNameOption;
  }

  const lastNameFirstLetter = lastName.charAt(0);

  return `${firstName} ${lastNameFirstLetter}`;
};
